<template>
<!--  <nav>-->
<!--    <router-link to="/">Home</router-link> |-->
<!--    <router-link to="/about">About</router-link>-->
<!--  </nav>-->
  <a-config-provider
      :locale="zhCN"
      :theme="{
        token: {
          colorPrimary: '#5178c6'
        },
      }"
      :component-config="componentConfig"
  >
    <router-view />
    <!-- AI 思考过程动画（全局组件） -->
    <AIThinkingOverlay ref="aiThinkingRef" @complete="onAIThinkingComplete" @step9-complete="onStep9Complete" :loadStatus="showAnimation" :api-completed="apiCompleted" :detail-data-loaded="detailDataLoaded" :start-step-index="startStepIndex" />
    <div class="loading" v-if="$store.state.loading !== 0"><a-spin size="large" /></div>
  </a-config-provider>
</template>

<script lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { storage } from '@/utils/storage'
import { loanApplyProduct } from "@/api/loan";
import {getAmazonCountryList} from "@/api";
import { Empty } from 'ant-design-vue'
import AIThinkingOverlay from "@/components/report/AIThinkingOverlay.vue";
import { useRouter } from 'vue-router';
dayjs.locale('zh');
export default defineComponent({
  components: {
    AIThinkingOverlay
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const aiThinkingRef = ref()

    // 从 Vuex 读取状态
    const showAnimation = ref(false)
    const apiCompleted = ref(false)
    const detailDataLoaded = ref(false)
    const startStepIndex = ref(0)

    // 监听 Vuex 状态变化
    watch(
      [() => store.state.aiAnimation.show, () => store.state.aiAnimation.apiCompleted, () => store.state.aiAnimation.detailDataLoaded, () => store.state.aiAnimation.startStepIndex],
      ([show, apiDone, dataLoaded, stepIndex]) => {
        if (show && !showAnimation.value) {
          // 启动动画
          showAnimation.value = true
          console.log('启动全局 AI 动画')
        }
        // 同步 apiCompleted 状态（包括重置为 false 的情况）
        if (apiDone !== apiCompleted.value) {
          apiCompleted.value = apiDone
          if (apiDone) {
            console.log('API 完成，继续播放第 9 步')
          } else {
            console.log('API 状态重置为 false')
          }
        }
        // 只有当 dataLoaded 为 true 时才更新（避免覆盖）
        if (dataLoaded === true && !detailDataLoaded.value) {
          detailDataLoaded.value = dataLoaded
          console.log('详情页数据加载完成', dataLoaded)
        }
        if (stepIndex !== undefined && stepIndex !== startStepIndex.value) {
          // 起始步骤索引变化
          startStepIndex.value = stepIndex
          console.log('设置起始步骤索引:', stepIndex)
        }
      },
      { immediate: true }
    )

    // 第 9 步完成的回调（API 完成 + 第 9 步播放完成）
    const onStep9Complete = () => {
      console.log('第 9 步完成，准备跳转详情页');
      // 从 Vuex 获取要跳转的报告 ID
      const reportId = store.state.aiAnimation.reportId
      if (reportId) {
        router.push('/report/detail/' + reportId)
      }
    }

    const onAIThinkingComplete = () => {
      console.log('AI 思考过程全部完成');
      showAnimation.value = false
      // 重置 Vuex 状态
      store.commit('RESET_AI_ANIMATION')
    }

    // 恢复登录态和登录成功后都加载人员列表，避免必须刷新整个页面。
    watch(() => store.getters.token, token => {
      if (token) store.dispatch('loadBdOptions')
    }, { immediate: true })

    onMounted (() => {
      const user = storage.get(process.env.VUE_APP_COOKIE_KEY)
      if (user) {
        store.commit('SET_USER', user)
        loanApplyProduct().then(res => {
          store.commit('setLoanOptions', res.data)
        })
      }
    })

    // 全局组件配置
    const componentConfig = {
      empty: {
        image: Empty.PRESENTED_IMAGE_SIMPLE
      }
    }
    return {
      zhCN, componentConfig, aiThinkingRef, showAnimation, apiCompleted, detailDataLoaded, startStepIndex, onStep9Complete, onAIThinkingComplete
    }
  }
});
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1111;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
